<template>
  <div :class="wrapCls">
    <input
      :id="elementId"
      ref="input"
      tabindex="0"
      :class="inputCls"
      v-bind="$attrs"
      :type="currentType"
      :value="currentValue"
      :disabled="disabled"
      :autocomplete="autocomplete"
      @keyup.enter="_enterHandler"
      @keyup="_keyupHandler"
      @keydown="_keydownHandler"
      @keypress="_keypressHandler"
      @focus="_focusHandler"
      @blur="_blurHandler"
      @input="_inputHandler"
      @change="_changeHandler"
      @click="_click"
      @compositionstart="_compositionHandler"
      @compositionupdate="_compositionHandler"
      @compositionend="_compositionHandler"
    />
    <span v-if="clearable || password" class="tt-input-suffix">
      <Icon
        v-if="clearable"
        name="close"
        class="tt-input-clear"
        @click.native.stop="_clearText"
      />
      <Icon
        v-if="password"
        :name="currentType === 'password' ? 'eyes-close' : 'eyes-open'"
        class="tt-input-password"
        @click.native.stop="_changeType"
      />
    </span>
  </div>
</template>
<script>
import broadcastMixin from 'mixins/broadcastMixin'
import Icon from 'com/Icon'
const prefixCls = 'tt-input'
export default {
  name: 'Input',
  components: { Icon },
  props: {
    value: String | Number,
    size: String,
    theme: String,
    password: Boolean,
    disabled: Boolean,
    clearable: Boolean,
    type: String,
    elementId: String,
    autocomplete: {
      type: String,
      default: 'off'
    },
    // 是否是表单中的输入框（表单输入框需要传递事件到表单收集）
    form: {
      type: Boolean,
      default: true
    }
  },
  mixins: [broadcastMixin],
  data() {
    return {
      prefixCls,
      isOnComposition: false,
      currentValue: this.value,
      currentType: this.type
    }
  },
  watch: {
    value(value) {
      this.currentValue = value
    },
    type(type) {
      this.currentType = type
    },
    currentValue(value) {
      this.form && this.dispatch('FormItem', 'on-form-change', value)
    }
  },
  computed: {
    wrapCls() {
      return {
        [`${prefixCls}-wrap`]: true
      }
    },
    inputCls() {
      return {
        [prefixCls]: true,
        [`${prefixCls}-size--${this.size}`]: this.size,
        [`${prefixCls}-disabled`]: this.disabled,
        [`${prefixCls}-with-suffix`]: this.clearable || this.password
      }
    }
  },
  methods: {
    _enterHandler(evt) {
      this.$emit('on-enter', evt)
    },
    _keyupHandler(evt) {
      this.$emit('on-keyup', evt)
    },
    _keydownHandler(evt) {
      this.$emit('on-keydown', evt)
    },
    _keypressHandler(evt) {
      this.$emit('on-keypress', evt)
    },
    _focusHandler(evt) {
      this.$emit('on-focus', evt)
    },
    _blurHandler(evt) {
      this.$emit('on-blur', evt)
      this.form && this.dispatch('FormItem', 'on-form-blur', this.currentValue)
    },
    _inputHandler(evt) {
      if (this.isOnComposition) return
      const value = evt.target.value
      this.$emit('input', value)
      this.currentValue = value
      this.$emit('on-change', evt)
    },
    _changeHandler(evt) {
      this.$emit('on-change', evt)
    },
    _compositionHandler(evt) {
      if (evt.type === 'compositionstart') {
        this.isOnComposition = true
      }
      if (evt.type === 'compositionend') {
        this.isOnComposition = false
        this._inputHandler(evt)
      }
    },
    _changeType() {
      if (this.currentType === 'password') {
        this.currentType = this.type === 'password' ? 'text' : this.type
      } else {
        this.currentType = 'password'
      }
    },
    _click(evt) {
      this.$emit('click', evt)
    },
    _clearText() {
      this.currentValue = ''
    },
    focus() {
      this.$refs.input.focus()
    },
    blur() {
      this.$refs.input.blur()
    },
    select() {
      this.$refs.input.select()
    }
  }
}
</script>
<style lang="less">
@import './index.less';
</style>
